import {publicFeatureFlagKeys as PUBLIC_FEATURE_FLAG_KEYS} from '../constants/public-feature-flag-keys';

export function PublicFeatureFlagsService(PublicFeatureFlagsApi) {
    const service = this;

    service.keys = PUBLIC_FEATURE_FLAG_KEYS;

    service.retrieveFlag = function retrieveFlag(flagName) {
        return PublicFeatureFlagsApi.retrieveFlag({'flagName': flagName});
    };

    return service;
}

PublicFeatureFlagsService.$inject = ['PublicFeatureFlagsApi'];
